<template lang="pug">
.screen
  router-link(
    :to="{name: 'exhibition-single', params: {year: startYear, id: exhibition.uid }}"
  )
    .preview-home
      img.cover(:src="exhibition.mainImage" :alt="exhibition.title")
      .captions
        h2.h-xl.ex-title
          | {{ title }}
        h4.h-l
          | {{ displayDate }}
</template>

<script>
export default {
  name: 'home-exhibition',

  props: ['exhibition'],

  computed: {
    startDate () {
      return this.exhibition.content.start_date
    },

    endDate () {
      return this.exhibition.content.end_date
    },

    startYear () {
      return this.exhibition.content.start_year
    },

    endYear () {
      return this.exhibition.content.end_year
    },

    /* eslint-disable */
    displayDate () {
      const dd = this.exhibition.content.display_date
      return !!dd ? dd : this.date
    },
    /* eslint-enable */

    date () {
      const endDate = this.endDate + ', ' + this.endYear
      let startDate = startDate = this.startDate
      if (this.endYear !== this.startYear) {
        startDate = this.startDate + ', ' + this.startYear
      }
      return startDate + ' - ' + endDate
    },

    title () {
      return this.exhibition.content.title
    }
  }
}
</script>

<style lang="sass">
@import '../../styles/_variables'
@import '../../styles/_mixins'
.screen
  height: 100vH
  position: relative
  @include respond-to(xs)
    height: 52vW
  .preview-home
    width: 100%
    height: 100%
    .captions
      position: absolute
      padding-bottom: $margin
      padding-top: 35vH
      bottom: 0
      width: 100vW
      color: #FFF
      background: linear-gradient(rgba(255,255,255,0), rgba(0,0,0,0.9))
      @include respond-to(xs)
        height: unset
        background: linear-gradient(rgba(255,255,255,0), rgba(0,0,0,0.75))
      >*
        padding-left: $margin
      h3
        padding-bottom: 1rem
        @include respond-to(xs)
          padding-bottom: 0
          display: none
      .ex-title
        font-style: italic
        width: 60%
        @include respond-to(xs)
          width: 90%
</style>



// WEBPACK FOOTER //
// HomeExhibition.vue?8cbbdf7c